import { render, staticRenderFns } from "./BoletinPeriodoGranColombiano.vue?vue&type=template&id=caef4be4&scoped=true&"
import script from "./BoletinPeriodoGranColombiano.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodoGranColombiano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caef4be4",
  null
  
)

export default component.exports